import request from '@/utils/request'

//获取路由
export function getRouter(data){
  return request({
    url:'/api-sp/sp/menu/userMenus',
    method:"post",
    data:data,
  })
} 

//首页信息
export function getOverallApi(data){
  return request({
    url:'/api-sp/sp/homePage/overall',
    method:"post",
    data:data,
  })
} 

//获取按钮权限
export function userPermsApi(data){
  return request({
    url:'/api-sp/sp/menu/userPerms',
    method:"post",
    data:data,
  })
}

//个人中心验证公司名称
export function checkCompanyNameApi(data){
  return request({
    url:'/api-sp/sp/corp/checkCompanyName',
    method:'post',
    data:data,
    headers:{
      'Content-Type': "application/json; charset=utf-8",
    }
  })
}

//个人中心获取公司信息
export function getCompanyInforApi(data){
  return request({
    url:'/api-sp/sp/corp/info',
    method:'post',
    data:data,
    headers:{
      'Content-Type': "application/json; charset=utf-8",
    }
  })
}

//修改个人中心信息
export function updatePersonalCenterApi(data){
  return request({
    url:'/api-sp/sp/user/updPersonalCenter',
    method:'post',
    data:data,
  })
}